require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row1.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row2.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row3.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row4.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row5.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row6.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row7.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row8.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row9.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row10.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row11.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row12.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row13.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row14.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row15.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row16.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row17.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row18.js');
require('../../jsy_do_widokow_z_salami/sale/amfiteatr/row19.js');
